<template>
  <div v-if="currentTache">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="w-100">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr class="px-2">
                  <td class="d-flex justify-content-between row">
                    <div class="d-flex col-md-6 justify-content-between">
                      <span class="font-weight-bold mr-4"
                        ><i class="fa fa-info-circle text-custom-primary"></i>
                        Titre
                      </span>
                      <span>{{ currentTache.titre }}</span>
                    </div>

                    <div class="d-flex col-md-6 justify-content-between">
                      <span class="font-weight-bold"
                        ><i class="far fa-user text-custom-primary"></i>
                        Auteur
                      </span>
                      <span>{{ currentTache.auteur }}</span>
                    </div>
                  </td>
                </tr>
                <tr class="px-2">
                  <td class="d-flex justify-content-between row">
                    <div class="d-flex col-md-6 justify-content-between">
                      <span class="font-weight-bold mr-4"
                        ><i class="far fa-calendar text-custom-primary"></i>
                        Date début
                      </span>
                      <span>{{ currentTache.date_debut }}</span>
                    </div>

                    <div class="d-flex col-md-6 justify-content-between">
                      <span class="font-weight-bold"
                        ><i class="far fa-calendar text-custom-primary"></i>
                        Date fin
                      </span>
                      <span>{{ currentTache.date_fin }}</span>
                    </div>
                  </td>
                </tr>
                <tr class="px-2">
                  <td class="d-flex justify-content-between row">
                    <div class="d-flex col-md-6 justify-content-between">
                      <span class="font-weight-bold mr-4"
                        ><i class="fa fa-info-circle text-custom-primary"></i>
                        Priorite
                      </span>
                      <span
                        ><i
                          :class="icons.ICON_STATUT"
                          class="mr-1"
                          :style="`color: ${currentTache.priorite.couleur}`"
                        ></i>
                        {{ currentTache.priorite.nom }}</span
                      >
                    </div>

                    <div class="d-flex col-md-6 justify-content-between">
                      <span class="font-weight-bold"
                        ><i class="fa fa-user text-custom-primary"></i>
                        Commercial
                      </span>
                      <span>{{ currentTache.employe }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="w-100 mt-2">
          <b-card
            class="text-black"
            header-class="bg-silver border-bottom-0"
            no-body
          >
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i :class="icons.ICON_DESCRIPTION" class="mr-1"></i>
                  Description
                </h5>
              </div>
            </template>
            <div class="row editor">
              <div class="col-md-12">
                <vue-editor
                  id="description"
                  v-model="currentTache.description"
                  :editorToolbar="VueEditorToolbar"
                  class="fonction-mission"
                  disabled
                />
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import icons from '@/icons/crm/mission_tache/tache';

import config from '@/config';

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      title: 'Gestion tâche - Détails',
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      VueEditorToolbar,
      icons,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('tache', ['currentTache']),
  },
  methods: {
    ...mapActions('tache', ['getTache']),
    init() {
      this.getTache(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
